import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-liste-reporting-op',
  templateUrl: './liste-reporting-op.component.html',
  styleUrls: ['./liste-reporting-op.component.css']
})
export class ListeReportingOpComponent implements OnInit {

  constructor() { }
  Traiter: any[] = [
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "nombre_contenu_ok" : '2',
      "nombre_contenu_ko" : '1',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "R",
      "complexite" : "complexe",
      "ptl" : 'Janne Doe',
      "operateur" : 1254,
      "nombre_contenu_ok" : '2',
      "nombre_contenu_ko" : '1',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "R1",
      "complexite" : "normal",
      "ptl" : 'Baby Doe',
      "operateur" : 1254,
      "nombre_contenu_ok" : '2',
      "nombre_contenu_ko" : '1',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "nombre_contenu_ok" : '2',
      "nombre_contenu_ko" : '1',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "R2",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "nombre_contenu_ok" : '2',
      "nombre_contenu_ko" : '1',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
  ];

  TraiteCols: any[] = [
    {field: 'type', header: 'Type'},
    {field: 'complexite', header: 'Complexité'},
    {field: 'ptl', header: 'PTL'},
    {field: 'operateur', header: 'Matricule OP'},
    {field: 'nombre_contenu_ok', header: 'Nombre Contenu Traité Status: OK'},
    {field: 'nombre_contenu_ko', header: 'Nombre Contenu Traité Status: KO'},
    {field: 'date_traitement', header: 'Date'},
    {field: 'heure_traitement', header: 'Heure'}
  ];
  CQ: any[] = [
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 520,
      "status_cq" : "KO",
      "nombre_contenu" : '3',
      "nombre_contenu_OK_CQ" : '2',
      "nombre_contenu_KO_CQ" : '1',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "R",
      "complexite" : "complexe",
      "ptl" : 'Janne Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 520,
      "status_cq" : "OK",
      "nombre_contenu" : '3',
      "nombre_contenu_OK_CQ" : '3',
      "nombre_contenu_KO_CQ" : '0',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "R1",
      "complexite" : "normal",
      "ptl" : 'Baby Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 520,
      "status_cq" : "OK",
      "nombre_contenu" : '3',
      "nombre_contenu_OK_CQ" : '3',
      "nombre_contenu_KO_CQ" : '0',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 520,
      "status_cq" : "OK",
      "nombre_contenu" : '3',
      "nombre_contenu_OK_CQ" : '3',
      "nombre_contenu_KO_CQ" : '0',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "R2",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 520,
      "status_cq" : "OK",
      "nombre_contenu" : '3',
      "nombre_contenu_OK_CQ" : '3',
      "nombre_contenu_KO_CQ" : '0',
      "date_traitement" : "01/07/2020",
      "heure_traitement" : "15:00:00"
    },
  ];

  CQCols: any[] = [
    {field: 'type', header: 'Type'},
    {field: 'complexite', header: 'Complexité'},
    {field: 'ptl', header: 'PTL'},
    {field: 'operateur_saisie', header: 'Matricule OP Saisie'},
    {field: 'operateur_cq', header: 'Matricule OP Cq'},
    {field: 'status_cq', header: 'Status CQ'},
    {field: 'nombre_contenu', header: 'Nombre Contenu Echantilloné'},
    {field: 'nombre_contenu_OK_CQ', header: 'Nombre Contenu Echantilloné CQ:OK'},
    {field: 'nombre_contenu_KO_CQ', header: 'Nombre Contenu Echantilloné CQ:KO'},
    {field: 'date_traitement', header: 'Date'},
    {field: 'heure_traitement', header: 'Heure'}
  ];
  /* ---- LISTE LIVRAISON  ---- */
  Livrer: any[] = [
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 1254,
      "nombre_contenu" : '3',
      "date_livraison" : "01/07/2020"
    },
    {
      "id" : 1,
      "type" : "R",
      "complexite" : "complexe",
      "ptl" : 'Janne Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 1254,
      "nombre_contenu" : '3',
      "date_livraison" : "01/07/2020"
    },
    {
      "id" : 1,
      "type" : "R1",
      "complexite" : "normal",
      "ptl" : 'Baby Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 1254,
      "nombre_contenu" : '3',
      "date_livraison" : "01/07/2020"
    },
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 1254,
      "nombre_contenu" : '3',
      "date_livraison" : "01/07/2020"
    },
    {
      "id" : 1,
      "type" : "R2",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur_saisie" : 1254,
      "operateur_cq" : 1254,
      "nombre_contenu" : '3',
      "date_livraison" : "01/07/2020"
    },
  ];

  LivrerCols: any[] = [
    {field: 'type', header: 'Type'},
    {field: 'complexite', header: 'Complexité'},
    {field: 'ptl', header: 'PTL'},
    {field: 'operateur_saisie', header: 'Matricule OP Saisie'},
    {field: 'operateur_cq', header: 'Matricule OP Cq'},
    {field: 'nombre_contenu', header: 'Nombre Contenu Livré'},
    {field: 'date_livraison', header: 'Date de Livraison'},
  ];
  ngOnInit(): void {
  }

}
